import type { ReactNode } from "react";

import type { BaseInputProps } from "../base-input/base-input";

import { useController, useFormContext } from "react-hook-form";

import { BaseInput } from "../base-input";

type TextInputProps = Omit<BaseInputProps, "type"> & {
	name: string;
};

export function TextInput({ name, ...props }: TextInputProps): ReactNode {
	const { control } = useFormContext();
	const { field, fieldState } = useController({ control, name });

	return (
		<BaseInput
			errorMessage={fieldState.error?.message}
			isInvalid={fieldState.invalid}
			onChange={field.onChange}
			value={(field.value as string | undefined) ?? ""}
			{...props}
			type="text"
		/>
	);
}
